var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComplaints(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "800px",
    height: "800px",
    viewBox: "0 0 64 64",
    id: "Layer_1_1_",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M32,17c-8.271,0-15,6.729-15,15s6.729,15,15,15s15-6.729,15-15S40.271,17,32,17z M32,45c-3.675,0-6.992-1.54-9.359-4   h18.718C38.992,43.46,35.675,45,32,45z M30.503,30.581C29.562,30.033,29,29.068,29,28v-2c0-0.838,0.355-1.645,0.974-2.212   c0.626-0.575,1.438-0.851,2.298-0.776C33.801,23.145,35,24.548,35,26.208V28c0,1.068-0.562,2.033-1.503,2.581L33,30.87v2.884   l4.84,1.383C39.112,35.5,40,36.678,40,38v1H24v-1c0-1.322,0.888-2.5,2.16-2.863L31,33.754V30.87L30.503,30.581z M42,40.295V38   c0-2.21-1.484-4.179-3.61-4.786L35,32.246v-0.266c1.246-0.939,2-2.416,2-3.979v-1.792c0-2.688-2.001-4.966-4.556-5.188   c-1.401-0.125-2.793,0.35-3.822,1.294C27.591,23.259,27,24.603,27,26v2c0,1.563,0.754,3.041,2,3.979v0.266l-3.39,0.969   C23.484,33.821,22,35.79,22,38v2.295c-1.872-2.253-3-5.144-3-8.295c0-7.168,5.832-13,13-13s13,5.832,13,13   C45,35.151,43.872,38.042,42,40.295z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54,7h-9.184C44.402,5.839,43.302,5,42,5h-3.383C37.321,2.529,34.799,1,32,1c-2.799,0-5.321,1.528-6.617,4H22   c-1.302,0-2.402,0.839-2.816,2H10c-1.654,0-3,1.346-3,3v50c0,1.654,1.346,3,3,3h44c1.654,0,3-1.346,3-3V10C57,8.346,55.654,7,54,7z    M51,49h-8v8H13V13h6v2h26v-2h6V49z M49.586,51L45,55.586V51H49.586z M21,8c0-0.551,0.449-1,1-1h4.618l0.487-0.975   C28.039,4.159,29.914,3,32,3s3.961,1.159,4.895,3.024L37.382,7H42c0.551,0,1,0.449,1,1v5H21V8z M55,60c0,0.551-0.449,1-1,1H10   c-0.551,0-1-0.449-1-1V10c0-0.551,0.449-1,1-1h9v2h-8v48h33.414L53,50.414V11h-8V9h9c0.551,0,1,0.449,1,1V60z"
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    width: 2,
    x: 39,
    y: 49
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    width: 22,
    x: 15,
    y: 49
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    width: 22,
    x: 15,
    y: 53
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    width: 2,
    x: 39,
    y: 53
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,5c-1.654,0-3,1.346-3,3s1.346,3,3,3s3-1.346,3-3S33.654,5,32,5z M32,9c-0.551,0-1-0.449-1-1s0.449-1,1-1s1,0.449,1,1   S32.551,9,32,9z"
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    width: 2,
    x: 24,
    y: 9
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    width: 2,
    x: 38,
    y: 9
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComplaints);
export default __webpack_public_path__ + "static/media/complaints.7f5276b8a647246470ed1525af42600c.svg";
export { ForwardRef as ReactComponent };